module.exports = __webpack_public_path__ + "assets/img/favicon/android-icon-96x96.fb7f7e66d564473ce87b17bfc26bd071.png";